import { useEffect, useState } from "react";
import {Link} from 'react-router-dom'
import YoutubePlayer from "../youtubePlayer";

export default function YtPlayer({ latestYoutubeVideo }) {



  const [video_id, setVideo_id] = useState(latestYoutubeVideo?.id || null);

  // useEffect(() => {
   
  //   if (latestYoutubeVideo?.id) return;

  //   async function loadLatestVideo() {
  //     try {
  //       const rssUrl =
  //         "https://www.youtube.com/feeds/videos.xml?channel_id=UCzVPlhwpWSrvTuGJ9-BP8vA";

  //       const response = await fetch(rssUrl);
  //       if (!response.ok) throw  new Error('response was not ok')
  //       const text = await response.text();

  //       const xml = new window.DOMParser().parseFromString(text, "text/xml");
  //       const entry = xml.querySelector("entry");
  //       if (!entry) return;

  //       const link = entry.querySelector("link")?.getAttribute("href");
  //       const id = new URL(link).searchParams.get("v");

  //       setVideo_id(id);
  //     } catch (error) {
  //       console.error("Failed to load YouTube feed:", error);
  //     }
  //   }

  //   loadLatestVideo();
  // }, [latestYoutubeVideo]);

  return (
    <>
      {video_id ? 
    
       <YoutubePlayer playerClass={"yt-player"}  videoId={video_id ? video_id : ' '} />

       : (
          <Link className="yt-player-redirect-div" to target="_blank" rel="noreferrer" >
               <img src="/comedy/assets/images/ad7-300x100-vanitha.png" alt='yt-player-redirect-img' />
          </Link>
      )}
    </>
  );
}

   